var portraitHeroImage = document.querySelectorAll(".hero-image__asset--portrait");

for (var i = 0; i < portraitHeroImage.length; i++) {
  if (portraitHeroImage[i].complete) {
    let imageWidth = portraitHeroImage[i].offsetWidth;
    portraitHeroImage[i].closest(".hero-image-wrapper").style.maxWidth = imageWidth + "px";
  }
}